<template>
  <div class="fixed inset-0 z-50 bg-white/60">
    <button type="button" :aria-label="$t('close')" @click="$emit('close')">
      <IconCross class="absolute right-4 top-4 z-[60] size-6 text-black" />
    </button>

    <Swiper
      :modules="[Navigation]"
      :initial-slide="activeIndex-1"
      slides-per-view="auto"
      :allow-touch-move="true"
      :navigation="true"
      class="customs-swiper-style-fullscreen h-full"
      @swiper="onSwiper"
    >
      <SwiperSlide
        v-for="(image,index) in images"
        :key="index"
        class="p-[5%]"
      >
        <!-- IMAGE -->
        <AppImage
          :src="image"
          loading="eager"
          class="size-full select-none object-contain"
        />
        {{ activeIndex }}
      </SwiperSlide>
    </Swiper>
  </div>
</template>

<script setup lang="ts">
import { useScrollLock } from '@vueuse/core'
import { Navigation } from 'swiper/modules'
import 'swiper/css/navigation'

const props = defineProps({
  open: {
    type: Boolean, default: false,
  },
  images: {
    type: Array, required: true,
  },
  activeIndex: {
    type: Number, default: 1,
  },
})

const body = ref(null)
let isLocked: any = null

let swiperInstance: any | null = null

function onSwiper(swiper: any) {
  swiperInstance = swiper
}

// watch activeIndex
watch(() => props.activeIndex, (value) => {
  if (swiperInstance) {
    swiperInstance.slideTo(value - 1)
  }
})

// watch open
watch(() => props.open, (value) => {
  if (value) {
    isLocked.value = true
  } else {
    isLocked.value = false
  }
})

onMounted(() => {
  // Since document.body is available only client-side, assign it here
  body.value = document.body
  isLocked = useScrollLock(body)
})

onUnmounted(() => {
  // Ensure the body is unlocked when the component is unmounted
  if (isLocked.value) {
    isLocked.value = false
  }
})

defineEmits(['close'])
</script>

<style>
.customs-swiper-style-fullscreen {
  .swiper-button-prev,
  .swiper-button-next {
    color: black;
  }
}
</style>
